import { Injectable } from '@angular/core';

import { WindowLocation, WindowShim } from './window-shim';

declare const window: WindowShim;

@Injectable()
export class WindowShimService {
  get window(): WindowShim {
    return window;
  }

  get document(): Document {
    return this.window.document;
  }

  get location(): WindowLocation {
    return this.window.location;
  }

  get pageYOffset(): number {
    return this.window.pageYOffset;
  }

  get innerHeight(): number {
    return this.window.innerHeight;
  }

  scrollTo(x: number, y: number): void {
    window.scrollTo(x, y);
  }

  addEventListener(type: string, handler: (event: Event) => void): void {
    window.addEventListener(type, handler);
  }
}
